export const getLocalKeys = (
  locales: __WebpackModuleApi.RequireContext
): string[] => locales.keys();

export default {
  getLocalKeys,
};
